import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { LocaleService } from '@shared/services/locale.service';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@shared/services/api.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { values } from 'lodash';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { User } from '@core/models';

@Component({
	selector: 'app-ads-analytics',
	templateUrl: './ads-analytics.component.html',
	styleUrls: ['./ads-analytics.component.scss'],
})
export class AdsAnalyticsComponent implements OnInit {
	loading: boolean = false;
	user: User = this.auth.user();
	socialOption = new UntypedFormControl('facebook');
	groupArray: any = [];
	resultsFb: any = [];
	resultsIg: any = [];
	resultsSn: any = [];
	resultsTk: any = [];
	adId: any;
	analyticsResponseFb: any;
	analyticsResponseIg: any;
	analyticsResponseSn: any;
	analyticsResponseTk: any;
	constructor(
		public locale: LocaleService,
		private httpClient: HttpClient,
		private api: ApiService,
		private title: Title,
		private route: ActivatedRoute,
		public auth: AuthService
	) {}

	onSelect(adId) {
		this.loading = true;
		let formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('adID', adId);
		formData.append('userID', this.user['userID']);
		this.api.socialMediaAnalytics(formData).subscribe((res) => {
			this.loading = false;
			if (res.response) {
				this.analyticsResponseFb = res.response.facebookShare;
				this.analyticsResponseIg = res.response.instagramShare;
				this.analyticsResponseSn = res.response.snapchatShare;
				this.analyticsResponseTk = res.response.tiktokShare;

				//for facebook
				this.analyticsResponseFb.map((d) => {
					d.timeOn = moment.unix(d.createdOn).format('DD/MM/YYYY hh:mm a');
					var result = d.timeOn.split('');
					var bindex = 0;
					var eindex = 10;
					result.splice(bindex, eindex - bindex);
					d.timeOn = result.join('');
					d.createdOn = moment.unix(d.createdOn).format('DD/MM/YYYY ');
					return d;
				});

				var groups = new Set(this.analyticsResponseFb.map((item) => item.createdOn)),
					results = [];
				groups.forEach((g) =>
					this.resultsFb.push({
						name: g,
						values: this.analyticsResponseFb.filter((i) => i.createdOn === g),
					})
				);

				// for Instagram
				this.analyticsResponseIg.map((d) => {
					d.timeOn = moment.unix(d.createdOn).format('DD/MM/YYYY hh:mm a');
					var result = d.timeOn.split('');
					var bindex = 0;
					var eindex = 10;
					result.splice(bindex, eindex - bindex);
					d.timeOn = result.join('');
					d.createdOn = moment.unix(d.createdOn).format('DD/MM/YYYY ');
					return d;
				});

				var groups = new Set(this.analyticsResponseIg.map((item) => item.createdOn)),
					results = [];
				groups.forEach((g) =>
					this.resultsIg.push({
						name: g,
						values: this.analyticsResponseIg.filter((i) => i.createdOn === g),
					})
				);

				//for snapchat
				this.analyticsResponseSn.map((d) => {
					d.timeOn = moment.unix(d.createdOn).format('DD/MM/YYYY hh:mm a');
					var result = d.timeOn.split('');
					var bindex = 0;
					var eindex = 10;
					result.splice(bindex, eindex - bindex);
					d.timeOn = result.join('');
					d.createdOn = moment.unix(d.createdOn).format('DD/MM/YYYY ');
					return d;
				});

				var groups = new Set(this.analyticsResponseSn.map((item) => item.createdOn)),
					results = [];
				groups.forEach((g) =>
					this.resultsSn.push({
						name: g,
						values: this.analyticsResponseSn.filter((i) => i.createdOn === g),
					})
				);

				//for tiktok
				this.analyticsResponseTk.map((d) => {
					d.timeOn = moment.unix(d.createdOn).format('DD/MM/YYYY hh:mm a');
					var result = d.timeOn.split('');
					var bindex = 0;
					var eindex = 10;
					result.splice(bindex, eindex - bindex);
					d.timeOn = result.join('');
					d.createdOn = moment.unix(d.createdOn).format('DD/MM/YYYY ');
					return d;
				});

				var groups = new Set(this.analyticsResponseTk.map((item) => item.createdOn)),
					results = [];
				groups.forEach((g) =>
					this.resultsTk.push({
						name: g,
						values: this.analyticsResponseTk.filter((i) => i.createdOn === g),
					})
				);
			}
		});
	}

	toFbUrl(id: any) {
		window.open('https://www.facebook.com/KurdShoppingKurdistan/posts/' + id, '_blank');
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['ads']['ad']['n307'] + ' | ' + this.locale.translations['header']['n0']);

		this.route.queryParams.subscribe((queries: Params) => {
			this.adId = queries['adID'];
		});
		this.onSelect(this.adId);
	}
}
